import React, { Component } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardText,
  Button
} from 'reactstrap';
import Map from './select_tier/Map.js';

class SelectTier extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prefectureTiers: null,
      tierExamples: []
    };

    this.tiers = [{
      number: 1,
      color: 'tier-one',
      prefectures: <span>Shanghai 上海市<br/>Shenzhen 深圳市<br/>Beijing 北京市<br/>Guangzhou 广州市</span>
    }, {
      number: 2,
      color: 'tier-two',
      prefectures: <span>Chengdu 成都市<br/>Suzhou 苏州市<br/>Dalian 大连市<br/>Wuhan 武汉市<br/>Hangzhou 杭州市<br/>Nanjing 南京市</span>
    }, {
      number: 3,
      color: 'tier-three',
      prefectures: <span>Hefei 合肥市<br/>Yantai 烟台市<br/>Huizhou 惠州市<br/>Xuzhou 徐州市<br/>Jiangmen 江门市<br/>Handan 邯郸</span>
    }, {
      number: 4,
      color: 'tier-four',
      prefectures: <span>Xiangfan 襄樊<br/>Bengbu 蚌埠市<br/>Jieyang 揭阳市<br/>Chengde 承德市<br/>Quzhou 衢州市<br/>Hengshui 衡水市</span>
    }];
  }

  componentDidMount() {
    fetch('/api/find_comparable_markets/tiers').then((resp) => resp.json())
      .then((respJson) => {
        this.setState({ prefectureTiers: respJson });
        this.createTierExamples(respJson);
      });
  }

  createTierExamples(prefectureTiers) {
    const tierExamples = [];

    prefectureTiers.forEach((prefecture) => {
      const index = prefecture.tier - 1;
      if (tierExamples[index] && tierExamples[index].length < 6) {
        tierExamples[index].push(prefecture);
      } else if (tierExamples[index] === undefined) {
        tierExamples[index] = [prefecture];
      }
    });

    this.setState({ tierExamples: tierExamples });
  }

  getColor(tier) {
    let color = '#ECEFF1';

    switch (tier) {
      case 1: color = '#DC3545';
        break;
      case 2: color = '#E25340';
        break;
      case 3: color = '#FFC107';
        break;
      case 4: color = '#29A645';
        break;
      default: break;
    }

    return color;
  }

  render() {
    const { tierExamples } = this.state;

    const tierCards = tierExamples.map((tierList, index) => {
      return (
        <Col md="6" className="mb-3" key={index}>
          <Card className="h-100 sl-panel">
            <CardHeader className={'text-white'} style={{ backgroundColor: this.getColor(index + 1) }}>
              Tier {index + 1} Prefectures
            </CardHeader>
            <CardBody className="d-flex flex-column">
              <CardText>{tierList.map((pref, i) => <span key={i}>{pref.name}&nbsp;{pref.chinese_name}<br/></span>)}</CardText>
              <Button
                className="text-white mt-auto sl-inline-action"
                style={{ backgroundColor: this.getColor(index + 1) }}
                tag="a"
                href={'/find_comparable_markets/tier/' + (index + 1)}
                block>
                Select Tier {index + 1}
              </Button>
            </CardBody>
          </Card>
        </Col>
      );
    });

    return (
      <Container fluid={true} className="sl-view-shell">
        <div className="sl-view-hero">
          <div>
            <div className="sl-view-kicker">Find Comparable Markets</div>
            <h1 className="sl-view-title">Choose A Prefecture Tier</h1>
            <p className="sl-view-subtitle">Start from market tier, then refine into prefectures and comparable locations.</p>
          </div>
          <span className="sl-view-meta">Step 1 of 4</span>
        </div>

        <Row className="sl-grid-gap">
          <Col md="5">
            <Map prefectureTiers={this.state.prefectureTiers} />
          </Col>
          <Col md="7">
            <Card className="mb-0 h-100 sl-panel">
              <CardHeader className="sl-panel-header">
                Select a prefecture tier that matches your comparable market criteria
              </CardHeader>
              <CardBody>
                <Container fluid={true}>
                  <Row>
                    {tierCards}
                  </Row>
                </Container>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default SelectTier;
